module.exports = __webpack_public_path__ + "public/img/tree.499a2300.png";